module.exports = __webpack_public_path__ + "9bad38568524aba3a1d7251467c5bce7.ttf";